import { ReadAloud } from '@3plearning/question-components-library';
import _ from 'lodash';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from '@lingui/macro';

import logo from '../../assets/images/mathletics-logo.svg';
import css from './header.scss';
import { BtnIcon } from '../../components/buttons';
import Profile from '../profile/profile';
import mathsAZIcon from '../../assets/images/MAZ_icon.svg';
import newTabIcon from '../../assets/images/MAZ_newtab_icon.svg';
import Resources from '../../helpers/resources';
import { closeUpf, getValueFromUrl } from '../../helpers/utils';
import { useLocalisation } from '../../helpers/i18n/use-localisation';

const Header = ({ onLocaleChange }) => {
  const { i18n } = useLocalisation();
  const mleReducer = useSelector(state => state.mleReducer);
  const standard = _.get(mleReducer, 'standardDescription', '');
  const journey = _.get(mleReducer, 'description', '');
  const firstName = _.get(mleReducer, 'user.firstName', '');
  const getMathsAZUrl = () => {
    const locale = getValueFromUrl('locale') || 'en-AU';
    const backUrl = encodeURIComponent(`${window.location.href}&close=true`);

    return `${window._env_.mathsAZUrl}?authToken=${Resources.env.authToken}&locale=${locale}&backUrl=${backUrl}`;
  };
  const mathsAZUrl = getMathsAZUrl();
  if (getValueFromUrl('close') === 'true') {
    window.close();
  }

  const headerRef = useRef(null);

  useEffect(() => {
    const root = headerRef.current;
    if (!root) {
      return undefined;
    }

    const restoreTabOrder = () => {
      const trigger = root.querySelector('[data-testid="read-aloud-btn"]');
      if (trigger && trigger.getAttribute('tabindex') === '-1') {
        trigger.removeAttribute('tabindex');
      }
    };

    restoreTabOrder();

    if (!window.MutationObserver) {
      return undefined;
    }

    const observer = new window.MutationObserver(restoreTabOrder);
    observer.observe(root, { childList: true, subtree: true, attributeFilter: ['tabindex'] });

    return () => observer.disconnect();
  }, []);

  return (
    <div className={css.header} ref={headerRef}>
      <div className={css.left}>
        <h1 className={css['logo-wrapper']}>
          <BtnIcon
            icon={logo}
            className={css.logo}
            title={i18n._(t`Mathletics Home`)}
            callBack={closeUpf}
          />
        </h1>
        <h2 className={css.text}>
          <p>{standard}</p>
          <span className={css['text-light']}>{journey}</span>
        </h2>
      </div>
      <div className={classNames(css.right, { [css['no-collapse']]: firstName.length <= 10 })}>
        <ReadAloud
          onConfigChange={({ locale }) => onLocaleChange(locale)}
          popoverLabels={{
            readAloud: i18n._(t`Read aloud`),
            transcribe: i18n._(t`Transcribe`)
          }}
        />
        {mathsAZUrl && <a
          className={css['maths-az-btn']}
          href={mathsAZUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={i18n._(t`Maths A-Z - open in new tab`)}
        >
          <img src={mathsAZIcon} alt="" className={css['hidden-in-portrait']} />
          <span><span className={css['hidden-in-portrait']}>Maths </span>A-Z</span>
          <img src={newTabIcon} alt="" className={css['new-tab-icon']} />
        </a>}
        <Profile firstName={firstName} />
      </div>
    </div>
  );
};

Header.propTypes = {
  onLocaleChange: PropTypes.func
};

export default Header;
